export const SET_CURRENT_PACK = 'SET_CURRENT_PACK';
export const CLOSE_CURRENT_PACK = 'CLOSE_CURRENT_PACK';
export const OPEN_GAME_MODE = 'OPEN_GAME_MODE';
export const CLOSE_GAME_MODE = 'CLOSE_GAME_MODE';
export const SET_PACK_INFO = 'SET_PACK_INFO';
export const OPEN_HELP = 'OPEN_HELP';
export const CLOSE_HELP = 'CLOSE_HELP';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const TOGGLE_DASHBOARD = 'TOGGLE_DASHBOARD';
export const TOGGLE_PACK_COMPLETE = 'TOGGLE_PACK_COMPLETE';





// WEBPACK FOOTER //
// ./src/actionCreators/uiActionNames.js